import React, { useState } from 'react';

// Stroked/filled glyphs matching the handoff icons (Icons.jsx is dormant — inlined).
function InfoIcon() {
  return (
    <svg
      width={15}
      height={15}
      viewBox='0 0 24 24'
      fill='currentColor'
      stroke='none'
      aria-hidden='true'
    >
      <circle
        cx='12'
        cy='12'
        r='9'
      />
      <rect
        x='11'
        y='10.5'
        width='2'
        height='6'
        rx='1'
        fill='#fff'
      />
      <circle
        cx='12'
        cy='7.6'
        r='1.2'
        fill='#fff'
      />
    </svg>
  );
}

function XIcon({ size = 14 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth={1.7}
      strokeLinecap='round'
      strokeLinejoin='round'
      aria-hidden='true'
    >
      <path d='M6 6l12 12M18 6L6 18' />
    </svg>
  );
}

function ChevronDownIcon({ rotated = false }) {
  return (
    <svg
      width={13}
      height={13}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth={1.7}
      strokeLinecap='round'
      strokeLinejoin='round'
      style={{ transform: rotated ? 'rotate(180deg)' : 'none' }}
      aria-hidden='true'
    >
      <path d='M6 9l6 6 6-6' />
    </svg>
  );
}

// Bravo amber info callout (handoff: item-level-mass-edit .mie-info). Body copy
// comes in as children (<p> elements); optional chips render behind a
// collapsible toggle. Dismissal state belongs to the caller via onDismiss.
function InfoCallout({ children, chips = null, chipsLabel = 'countries', onDismiss = null }) {
  const [chipsOpen, setChipsOpen] = useState(false);
  const chipList = chips ?? [];

  return (
    <div className='bravo-ds'>
      <div className='mie-info'>
        <div className='mie-info-head'>
          <span className='ic'>
            <InfoIcon />
          </span>
          <b>Info</b>
          <div style={{ flex: 1 }} />
          {onDismiss && (
            <button
              type='button'
              className='mie-info-x'
              onClick={onDismiss}
              aria-label='Dismiss info'
            >
              <XIcon />
            </button>
          )}
        </div>
        {children}
        {chipList.length > 0 && (
          <>
            <button
              type='button'
              className='mie-info-toggle'
              onClick={() => setChipsOpen(!chipsOpen)}
              aria-expanded={chipsOpen}
            >
              <ChevronDownIcon rotated={chipsOpen} />
              {`${chipsOpen ? 'Hide' : 'Show'} ${chipList.length} ${chipsLabel}`}
            </button>
            {chipsOpen && (
              <div className='mie-countries'>
                {chipList.map((chip) => (
                  <span
                    key={chip}
                    className='mie-country-chip'
                  >
                    {chip}
                  </span>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default InfoCallout;
